import { Card, CardTitle } from "@/core/components/ui/card";
import { cn } from "@/core/utils/utils";

interface DashboardPaneCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  title?: string;
  style?: React.CSSProperties;
}

export const DashboardPaneCard = ({
  children,
  className,
  title,
  ...props
}: DashboardPaneCardProps) => (
  <Card className={cn("w-full rounded-2xl", className)} {...props}>
    {title && <CardTitle className="p-4">{title}</CardTitle>}
    {children}
  </Card>
);
